var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.26347C9.27496 4.26347 6.66663 6.8718 6.66663 10.0968C6.66663 13.5718 10.35 18.3635 11.8666 20.1885C12.2 20.5885 12.8083 20.5885 13.1416 20.1885C14.65 18.3635 18.3333 13.5718 18.3333 10.0968C18.3333 6.8718 15.725 4.26347 12.5 4.26347ZM12.5 12.1801C11.35 12.1801 10.4166 11.2468 10.4166 10.0968C10.4166 8.9468 11.35 8.01347 12.5 8.01347C13.65 8.01347 14.5833 8.9468 14.5833 10.0968C14.5833 11.2468 13.65 12.1801 12.5 12.1801Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.99ba9b8edc1052c54e1b569259323fde.svg";
export { ForwardRef as ReactComponent };